
// task
export const SET_TASK_LIST = 'SET_TASK_LIST'

// analyse
export const SET_ANALYSE_TASK_LIST = 'SET_ANALYSE_TASK_LIST'
export const SET_ANALYSE_TASK_LIST_PAGE = 'SET_ANALYSE_TASK_LIST_PAGE'
export const SET_ANALYSE_TASK_LIST_PAGE_TOTAL = 'SET_ANALYSE_TASK_LIST_PAGE_TOTAL'
export const SET_ANALYSE_TASK_LIST_QUERY = 'SET_ANALYSE_TASK_LIST_PAGE_QUERY'
export const SET_ANALYSE_TASK_STATE_TYPE = 'SET_ANALYSE_TASK_STATE_TYPE'
export const SET_ANALYSE_LIST_PAGE_SIZE = 'SET_ANALYSE_LIST_PAGE_SIZE'
export const SET_ANALYSE_SORT = 'SET_ANALYSE_SORT'
export const SET_ANALYSE_RUNNING_STATUS = 'SET_ANALYSE_RUNNING_STATUS'
export const SET_ANALYSE_END_STATUS = 'SET_ANALYSE_END_STATUS'
export const SET_ANALYSE_SEARCHING = 'SET_ANALYSE_SEARCHING'
export const CHANGE_ANALYSE_QUERY = 'CHANGE_ANALYSE_QUERY'
export const RESET_ANALYSE_TASK_LIST_QUERY = 'RESET_ANALYSE_TASK_LIST_QUERY'

// render
export const SET_RENDER_LIST = 'SET_RENDER_LIST'
export const SET_RENDER_LIST_PAGE = 'SET_RENDER_LIST_PAGE'
export const SET_RENDER_LIST_PAGE_TOTAL = 'SET_RENDER_LIST_PAGE_TOTAL'
export const SET_RENDER_LIST_QUERY = 'SET_RENDER_LIST_PAGE_QUERY'
export const SET_RENDER_SORT = 'SET_RENDER_SORT'
export const SET_RENDER_LIST_EXPEND = 'SET_RENDER_LIST_EXPEND'
export const SET_RENDER_LIST_PACK_UP = 'SET_RENDER_LIST_PACK_UP'
export const SET_RENDER_LIST_PAGE_SIZE = 'SET_RENDER_LIST_PAGE_SIZE'
export const SET_RENDER_TASK_STATE_TYPE = 'SET_RENDER_TASK_STATE_TYPE'
export const SET_RENDER_TASK_COUNT = 'SET_RENDER_TASK_COUNT'
export const SET_RENDERING_LIST_QUERY = 'SET_RENDERING_LIST_QUERY'
export const SET_RENDEREND_LIST_QUERY = 'SET_RENDEREND_LIST_QUERY'
export const SET_RENDERING_STATUS_LIST = 'SET_RENDERING_STATUS_LIST'
export const SET_RENDEREND_STATUS_LIST = 'SET_RENDEREND_STATUS_LIST'
export const SET_RENDER_RUNNING_SEARCHING = 'SET_RENDER_RUNNING_SEARCHING'
export const SET_RENDER_END_SEARCHING = 'SET_RENDER_END_SEARCHING'
export const SET_RENDER_END_EXPORTING = 'SET_RENDER_END_EXPORTING'
export const SET_CONFIG_FILE = 'SET_CONFIG_FILE'
export const SET_MULTI_FRAME_CONFIG_FILE = 'SET_MULTI_FRAME_CONFIG_FILE'
export const IS_MULTI_FRAME = 'IS_MULTI_FRAME'
export const IS_HOUDINI_SINGLE = 'IS_HOUDINI_SINGLE'
export const RESET_RENDERING_LIST_QUERY = 'RESET_RENDERING_LIST_QUERY'
export const RESET_RENDEREND_LIST_QUERY = 'RESET_RENDEREND_LIST_QUERY'
export const SET_FRAME_STATISTIC_MESSAGE = 'SET_FRAME_STATISTIC_MESSAGE'
export const SET_TASK_SCENE_TYPE = 'SET_TASK_SCENE_TYPE'
export const SET_TASK_TYPE = 'SET_TASK_TYPE'
export const SET_TASK_PARAM_OBJECT = 'SET_TASK_PARAM_OBJECT'
export const SET_JSON_LIST_LOADING = 'SET_JSON_LIST_LOADING'
export const SET_JSON_CUSTOM_MADE_LIST = 'SET_JSON_CUSTOM_MADE_LIST'
export const SET_RENDER_PAGE_COUNT = 'SET_RENDER_PAGE_COUNT'

// search
export const SET_SEARCH_LIST_PAGE = 'SET_SEARCH_LIST_PAGE'
export const SET_SEARCH_LIST_PAGE_TOTAL = 'SET_SEARCH_LIST_PAGE_TOTAL'
export const SET_SEARCH_LIST = 'SET_SEARCH_LIST'
export const SET_SEARCH_SORT = 'SET_SEARCH_SORT'
export const SET_SEARCH_LIST_EXPEND = 'SET_SEARCH_LIST_EXPEND'
export const SET_SEARCH_LIST_PACK_UP = 'SET_SEARCH_LIST_PACK_UP'
export const SET_SEARCH_LIST_PAGE_SIZE = 'SET_SEARCH_LIST_PAGE_SIZE'
export const SET_SEARCH_TASK_ID = 'SET_SEARCH_TASK_ID'
export const SET_RENDER_TASK_LIST = 'SET_RENDER_TASK_LIST'

// handle
export const SET_TASK_GROUP = 'SET_TASK_GROUP'
export const SET_DETAIL_IMG_MESSAGE = 'SET_DETAIL_IMG_MESSAGE'
export const SET_JIGSAW_PREVIEW = 'SET_JIGSAW_PREVIEW'

// preHandle
export const SET_PRE_HANDLE_LIST = 'SET_PRE_HANDLE_LIST'
export const SET_PRE_HANDLE_LIST_PAGE = 'SET_PRE_HANDLE_LIST_PAGE'
export const SET_PRE_HANDLE_SORT = 'SET_PRE_HANDLE_SORT'
export const SET_PRE_HANDLE_LIST_QUERY = 'SET_PRE_HANDLE_LIST_QUERY'
export const SET_PRE_HANDLE_LIST_PAGE_TOTAL = 'SET_PRE_HANDLE_LIST_PAGE_TOTAL'
export const SET_PRE_HANDLE_LIST_PAGE_SIZE = 'SET_PRE_HANDLE_LIST_PAGE_SIZE'
export const SET_PRE_HANDLE_SEARCHING = 'SET_PRE_HANDLE_SEARCHING'
export const RESET_PRE_HANDLE_LIST_QUERY = 'RESET_PRE_HANDLE_LIST_QUERY'
